import firebase from "firebase";
import { notification } from "antd";
import {
  sendNotificationStatusChecker,
  setNotificationDefaultSettings,
} from "./helpers";
import { sendToken } from "./pushNotification.api";
import { hasOwnNestedProperty, isLogin } from "../constant/helper";

export const initializeFirebase = async () => {
  firebase.initializeApp({
    apiKey: "AIzaSyDJnePMEhNgD0sJmTVpfePMImk0UQntCpk",
    authDomain: "lawone-78230.firebaseapp.com",
    databaseURL: "https://lawone-78230.firebaseio.com",
    projectId: "lawone-78230",
    storageBucket: "lawone-78230.firebasestorage.app",
    messagingSenderId: "619438370898",
    appId: "1:619438370898:web:07bbce1340b4c7df49af8b",
    measurementId: "G-WYMG7712RX",
  });

  const analytics = firebase.analytics();
  analytics.logEvent("Client_pwa");

  await setNotificationDefaultSettings(); // Set Default Notification Settings In LocalStorage
  await askForPermissioToReceiveNotifications(); // get permission for sending notifications
};

const askForPermissioToReceiveNotifications = async () => {
  try {
    const messaging = firebase.messaging();

    let token;
    const oldToken = localStorage.getItem("firebaseToken");
    if (oldToken) {
      token = oldToken;
    } else {
      const newToken = await messaging.getToken();
      token = newToken;
    }

    if (isLogin()) {
      sendToken(token).then((r) => {
        localStorage.setItem("firebaseToken", token);
      });
    }

    messaging.onMessage((payload) => {
      if (sendNotificationStatusChecker()) {
        notification.info({
          message: hasOwnNestedProperty(payload, "data.title")
            ? payload.data.title
            : "",
          description: hasOwnNestedProperty(payload, "data.body")
            ? payload.data.body
            : "",
          placement: "topLeft",
        });
      }
    });
    return token;
  } catch (error) {
    console.error("push :  error : ", error);
    if (
      error?.message ===
      `FirebaseError: Messaging: This browser doesn't support the API's required to use the firebase SDK. (messaging/unsupported-browser).`
    ) {
    }
  }
};
